import { createContext } from 'react';
import { IModalVariants, modalVariants } from './modal.variants';

export type ModalContextProps = {
  name?: string;
  variant?: keyof typeof modalVariants | (string & {});
  variants?: IModalVariants;
  onConfirm: () => void;
};

export const ModalContext = createContext<ModalContextProps>({
  name: 'modal',
  onConfirm: () => { },
});

export const ModalProvider = ModalContext.Provider;
